import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { authGuard } from 'ish-core/guards/auth.guard';
import { notFoundStatusGuard } from 'ish-core/guards/not-found-status.guard';
import { matchCategoryRoute } from 'ish-core/routing/category/category.route';
import { matchContentRoute } from 'ish-core/routing/content-page/content-page.route';
import { matchProductRoute } from 'ish-core/routing/product/product.route';

//import { icsaLastRoutes } from '../extensions/dot-cms/pages/dot-cms-routing.module';

const routes: Routes = [
  {
    matcher: matchProductRoute,
    canActivate: [authGuard],
    loadChildren: () => import('./product/product-page.module').then(m => m.ProductPageModule),
  },
  {
    matcher: matchCategoryRoute,
    canActivate: [authGuard],
    loadChildren: () => import('./category/category-page.module').then(m => m.CategoryPageModule),
  },
  /* DIAS PWA Customizations Start */
  {
    matcher: matchContentRoute,
    loadChildren: () => import('./content/content-page.module').then(m => m.ContentPageModule),
  },
 // ...icsaLastRoutes,

  /* DIAS PWA Customizations End */
  {
    path: '**',
    canActivate: [notFoundStatusGuard],
    loadChildren: () => import('./error/error-page.module').then(m => m.ErrorPageModule),
    data: {
      meta: {
        title: 'seo.title.error',
        robots: 'noindex, nofollow',
      },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class AppLastRoutingModule {}
